import { useState } from "react";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import WhatsappTriggerForm from "./WhatsappTriggerForm";

export default function WhatsappTriggerCreate(props) {
  const {
    onTriggerCreate,
    assistants,
    whatsappTemplates,
    mcubeEngageTemplates,
    whatsappConfiguration,
    mcubeEngageConfiguration,
  } = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        color="white"
        onClick={() => setOpen(true)}
      >
        <PlusIcon />
        Add Trigger
      </Button>
      <Dialog
        size="xl"
        onClose={() => setOpen(false)}
        open={open}
      >
        <DialogTitle>Add Whatsapp Trigger</DialogTitle>
        <DialogBody>
          <WhatsappTriggerForm
            whatsappTrigger={{}}
            onCancel={() => setOpen(false)}
            onSubmit={onTriggerCreate}
            assistants={assistants}
            whatsappTemplates={whatsappTemplates}
            whatsappConfiguration={whatsappConfiguration}
            mcubeEngageTemplates={mcubeEngageTemplates}
            mcubeEngageConfiguration={mcubeEngageConfiguration}
          />
        </DialogBody>
      </Dialog>
    </>
  );
}
